import React from 'react'

export default function Description({message, bold, link}) {
    if( link !== undefined) {
        return <div style={{marginBottom: 10, fontWeight: bold ? "bold" : "normal", textDecoration:"none"}}><a href={link} target={"_blank"} rel="noopener noreferrer">{message}</a></div>
    }
    return <div style={{marginBottom: 10, fontWeight: bold ? "bold" : "normal"}}>{message}</div>
}
